import { Box, Typography } from '@mui/material';
import React from 'react';

const UserPreferences = () => {
  return (
    <Box>
      <Typography variant='h4'>User Preferences</Typography>
      <Typography variant='h6'>Coming Soon</Typography>
    </Box>
  );
};

export default UserPreferences;
